import React from "react";
import { GiChessKing } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import "./ColorPicker.css";
import { useGlobalContext } from "../context";
import { Link } from "react-router-dom";
import EngineStrengthPicker from "./EngineStrengthPicker";

const ColorPicker = ({ fen }) => {
  const {
    setShowColorPicker,
    setStartPosition,
    setPiecesColor,
    setBoardOrientation,
  } = useGlobalContext();

  // start chess game from current position with picked color
  const startFromCurrentPosition = (pickedColor) => {
    setStartPosition(fen);
    if (pickedColor === "w") {
      setPiecesColor(1);
      setBoardOrientation("white");
    } else {
      setPiecesColor(0);
      setBoardOrientation("black");
    }
    setShowColorPicker(false);
  };

  return (
    <div className="color-picker-conatiner">
      <MdClose
        className="close"
        onClick={() => {
          setShowColorPicker(false);
        }}
      />
      <h3>Wybierz moc silnika</h3>
      <div className="separator"></div>
      <div className="strength-picker">
        <EngineStrengthPicker />
      </div>
      <h3>Wybierz kolor</h3>
      <div className="separator"></div>
      <div className="color-picker-btns">
        <Link to="/play-classic">
          <button
            className="btn btn-blue"
            onClick={() => startFromCurrentPosition("w")}
          >
            <GiChessKing />
          </button>
        </Link>
        <Link to="/play-classic">
          <button
            className="btn btn-blue"
            onClick={() => startFromCurrentPosition("b")}
          >
            <GiChessKing style={{ color: "black" }} />
          </button>
        </Link>
      </div>
    </div>
  );
};

export default ColorPicker;
